import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { colors } from "../../../../ui/colors";
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left";
import { Layout } from "../../../../ui/layout";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { MenuItems } from "../../../../ui/organisms/navbar/dto";
import { ReinforcedControlMeasureUpdate, ReinforcedControlMeasureValidation, resetReinforcedControlMeasureValidation } from "../slice";
import { ReinforcedControlMeasureEditForm } from "./forms";

export function EditReinforcedControlMeasure() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const reinforcedControlMeasureState = useAppSelector(state => state.reinforcedControlMeasure)

    useEffect(() => {
        if (reinforcedControlMeasureState.reinforcedControlMeasureValidationStatus === 'successfully') {
            dispatch(resetReinforcedControlMeasureValidation())
            dispatch(ReinforcedControlMeasureUpdate({ body: reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest, id: reinforcedControlMeasureState.reinforcedControlMeasureIdToUpdate }))
        }
    }, [reinforcedControlMeasureState.reinforcedControlMeasureValidationStatus])

    useEffect(() => {
        if (reinforcedControlMeasureState.reinforcedControlMeasureUpdateStatus === 'successfully') {
            navigate('/reinforcedControlMeasure')
        }
    }, [reinforcedControlMeasureState.reinforcedControlMeasureUpdateStatus])

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Provvedimenti', 'Modifica Misura di Controllo Rinforzato']}
            noPaddingLat
            headerLabel="Misura di Controllo Rinforzato"
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/reinforcedControlMeasure')} color={colors.white} />
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Salva"
                        color={"orange"}
                        onClick={() => dispatch(ReinforcedControlMeasureValidation(reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest))}
                    />
                </div>
            }
        >
            <ReinforcedControlMeasureEditForm />
        </Layout>
    )
}